import {
  Box,
  Modal,
  Typography,
  Backdrop,
  CircularProgress,
  Grid,
  TextField,
} from "@mui/material";
import moment from "moment";
import MDButton from "components/MDButton";
import React, { useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import axios from "../../../../Uri";
import ExceedPayments from "./GuestCheckoutModule/GuestPaymentModule/GuestExceedPayments";
// import Moment from "react-moment";
const MuiModal1 = (props) => {
  let userData = JSON.parse(sessionStorage.getItem("userdata"));
  let userId = userData.data.userId;

  const [plannedCheckOutDate, setPlannedCheckOutDate] = useState("");

  const [open, setOpen] = useState(false);
  const [due, setDue] = useState(0);
  const [dues, setShowDue] = useState(false);
var newdate = props.guestdetails.plannedCheckOutDate.split("-").reverse().join("-")

  const handlerDue = () => {
    setShowDue(true);
    axios
      .put("/guest/dueForPlanExtensionForDandR", {
        guestId: props.guestdetails.id,
        plannedCheckOutDate: plannedCheckOutDate,
      })
      .then((res) => {
        setDue(res.data.body);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  return (
    <div>
      <Grid container spacing={1} sx={{ m: 2 }}>
        <Grid md={7} lg={7}>
          <Typography variant="h6" gutterBottom>
            Current Planned CheckOut Date :
          </Typography>
        </Grid>
        <Grid md={5} lg={5}>
          <Typography variant="h6" gutterBottom>
            {props.guestdetails.plannedCheckOutDate}
          </Typography>
        </Grid>
      </Grid>

      <div>
        
        {/* Commented this line so it should not give an otion to select new planned check out date 
         <Grid container spacing={1} sx={{ m: 2 }}>
          <Grid md={6} lg={6}>
            <Typography variant="h6" gutterBottom>
              Select Revised Planned CheckOut Date :
            </Typography>
          </Grid>
          <Grid md={6} lg={6}>
            <TextField
              type="date"
              inputProps={{
                min:newdate
              }}
              onChange={(e) => {
                setPlannedCheckOutDate(e.target.value);
              }}
            />
          </Grid>
        </Grid> 

        <div align="center">
          <MDButton
            sx={{ m: 2 }}
            align="center"
            variant="contained"
            color="error"
            onClick={handlerDue}
          >
            Show due
          </MDButton>
        </div>
        */}
        <Grid item xs={12} sx={{ marginTop: 2 }}>
          <Typography variant="h6" gutterBottom>
            Planned To be extended to{" "}
            {plannedCheckOutDate}, Guest have to
            pay ₹{Math.ceil(props.guestdetails.defaultRent)} /-
          </Typography>
        </Grid>
        <ToastContainer
          maxWidth="sx"
          position="top-right"
          autoClose={3000}
          type="toast.TYPE.SUCCESS"
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
      </div>
     
      {open !== true ?  (
        <>
          {" "}
          <MDButton
            color="warning"
            variant="contained"
            onClick={() => {

              setOpen(true);
              // setOpens("open")
            }}
          >
            Proceed to payment:{" "}
          </MDButton>
        </>
      ) : (
        <ExceedPayments
          guestdetails={props.guestdetails}
          plannedCheckOutDate={plannedCheckOutDate}
          DueAmount={due}
          editGuestHandler={props.editGuestHandler}
        />
      )}
    </div>
  );
};
export default MuiModal1;
